import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Authentication/Login";
import PanelLayout from "./Layout/PanelLayout";
import { panelRoutes } from "./panel/routes";
import { ProtectedRoute, PublicRoute } from "./routes/ProtectedRoute";

function App() {
  return (
    <Routes>
      <Route element={<PanelLayout bare />}>
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<PanelLayout />}>
          {panelRoutes
            .filter((r) => r.element)
            .map(({ path, element: Page, roles }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute roles={roles}>
                    <Page />
                  </ProtectedRoute>
                }
              />
            ))}
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
